/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();

// Menu hover
document.addEventListener('DOMContentLoaded', function() {
  // Get all the elements with the class 'navlink--toplevel'
  var links = document.querySelectorAll('.menu__item');

  links.forEach(function(link) {
    link.addEventListener('mouseenter', function() {
      // On hover, set opacity of the hovered link to 1
      this.style.opacity = '1';

      // Set opacity of all other links to 0.5
      links.forEach(function(otherLink) {
        if (otherLink !== link) {
          otherLink.style.opacity = '0.5';
        }
      });
    });

    link.addEventListener('mouseleave', function() {
      // Reset opacity to 1 for all links when hover ends
      links.forEach(function(otherLink) {
        otherLink.style.opacity = '1';
      });
    });
  });
});

// PLP filter link
document.addEventListener('DOMContentLoaded', function() {
  // Get all the elements with the class 'navlink--toplevel'
  var links = document.querySelectorAll('.highlights__item-inner');

  links.forEach(function(link) {
    link.addEventListener('mouseenter', function() {
      // On hover, set opacity of the hovered link to 1
      this.style.opacity = '1';

      // Set opacity of all other links to 0.5
      links.forEach(function(otherLink) {
        if (otherLink !== link) {
          otherLink.style.opacity = '0.5';
        }
      });
    });

    link.addEventListener('mouseleave', function() {
      // Reset opacity to 1 for all links when hover ends
      links.forEach(function(otherLink) {
        otherLink.style.opacity = '1';
      });
    });
  });
});


document.addEventListener("DOMContentLoaded", function () {

  //HP collection hover on mobile
const buttons = document.querySelectorAll("[data-hover-target]");

    buttons.forEach((button) => {
      const originalHref = button.getAttribute("data-url") || button.getAttribute("href");

      // If href is missing, store the intended target in data-url
      if (!originalHref || originalHref === "#") {
        // fallback: detect the real URL in your setup
        // example: <a data-url="/collections/rings" ...>
      }

      // Make clickable on mobile even without href
      button.setAttribute("role", "button");
      button.style.cursor = "pointer";

      const handleActivate = (e) => {
        const isAlreadySelected = button.classList.contains("is-selected");

        // If already selected → allow redirect to its URL
        if (isAlreadySelected && originalHref && originalHref !== "#") {
          window.location.href = originalHref;
          return;
        }

        // Otherwise, prevent navigation and just show the preview
        e.preventDefault();
        e.stopPropagation();

        const targetId = button.getAttribute("data-hover-target");
        const targetDiv = document.getElementById(targetId);

        if (!targetDiv) return;

        // Remove 'is-visible' from all images
        document.querySelectorAll("[data-collection-image]").forEach((div) => {
          div.classList.remove("is-visible");
        });

        // Remove 'is-selected' from all buttons
        buttons.forEach((btn) => btn.classList.remove("is-selected"));

        // Add active classes to the clicked one
        targetDiv.classList.add("is-visible");
        button.classList.add("is-selected");
      };

      button.addEventListener("click", handleActivate, { passive: false });
      button.addEventListener("touchstart", handleActivate, { passive: false });
    });

  });
